import React, { useEffect, useState } from 'react';

import Breadcrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';

import { Project } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

type Props = {
  project: Project;
};

export default function ReportBreadcrumbs({ project }: Props): JSX.Element {
  const [projectURL, setProjectURL] = useState('');
  const [allProjectsURL, setAllProjectsURL] = useState('');
  const [reportsURL, setReportsURL] = useState('');

  useEffect(() => {
    createLink();
  });

  const createLink = async () => {
    setProjectURL(
      StorageOfUniqueServices.get('URLService').getProjectURL(project.key)
    );
    setAllProjectsURL(
      await StorageOfUniqueServices.get('URLService').getAllProjectsURL()
    );
    setReportsURL(
      await StorageOfUniqueServices.get('URLService').getReportsURL(project.key)
    );
  };

  return (
    <div>
      <Breadcrumbs>
        <BreadcrumbsItem
          href={allProjectsURL}
          text='Projects'
          target='_parent'
        />
        <BreadcrumbsItem
          href={projectURL}
          text={project.name}
          target='_parent'
        />
        <BreadcrumbsItem href={reportsURL} text='Reports' target='_parent' />
      </Breadcrumbs>
    </div>
  );
}
